import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { db } from "../../utils/firebase";
import { collection, getDocs } from "firebase/firestore";
import "./TripInspiration.css";

const TripInspiration = () => {
  const [announcements, setAnnouncements] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "announcements"));
        const fetchedAnnouncements = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setAnnouncements(fetchedAnnouncements);
      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    };

    fetchAnnouncements();
  }, []);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="trip-inspirations">
      <h2 className="swiper-title">Bacoor Tourism Announcements</h2>
      <Slider {...settings}>
        {announcements.map((announcement) => (
          <div
            key={announcement.id}
            className="trip-card"
            onClick={() => navigate(`/announcement/${announcement.id}`)} // Navigate using dynamic ID
          >
            <img
              src={announcement.background || "/placeholder-image.jpg"}
              alt={announcement.title || "Announcement"}
              className="trip-image"
            />
            <div className="trip-details">
              <h3>{announcement.title || "Untitled"}</h3>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TripInspiration;
